import { Component, Inject, LOCALE_ID, OnInit, OnDestroy } from '@angular/core';
import { TicketDetailsComponent } from '../ticket-details/ticket-details.component';
import { ModalController, NavController } from '@ionic/angular';
import Env from '@ridango/core/env';
import { FormBuilder } from '@angular/forms';
import {
    AccountTicketsNgrxFacade,
    ApplicationFacade,
    FavoritesFacade,
    TicketsService,
    Ticket,
    ProductsFacade,
    ProductsService
} from '@ridango/components';
import { AppStartupService, AuthService, CoreFacade, NetworkService, TranslateObjectFieldPipe } from '@ridango/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService } from '@ridango/core/lib/services/analytics.service';
import { ScreenOrientationService } from '@ridango/core/lib/services/screenOrientation.service';
import { DateCalculationService } from '../../services/date-calculation.service';
import { TicketActionsService } from '../../services/ticket-actions/ticket-actions.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'rwidget-ticket-details-v2',
    templateUrl: './ticket-details-v2.component.html',
    styleUrls: ['./ticket-details-v2.component.scss']
})
export class TicketDetailsV2Component extends TicketDetailsComponent implements OnInit, OnDestroy {
    accordionValue?: string;
    travellers = '';

    constructor(
        @Inject('ENV') env: Env,
        @Inject(LOCALE_ID) locale: string,
        modalCtrl: ModalController,
        formBuilder: FormBuilder,
        accountTicketsFacade: AccountTicketsNgrxFacade,
        applicationFacade: ApplicationFacade,
        coreFacade: CoreFacade,
        appStartupService: AppStartupService,
        ticketService: TicketsService,
        private readonly ticketsFacade: AccountTicketsNgrxFacade,
        bpObservable: BreakpointObserver,
        favoritesFacade: FavoritesFacade,
        authService: AuthService,
        router: Router,
        activatedRoute: ActivatedRoute,
        translate: TranslateService,
        networkService: NetworkService,
        analyticsService: AnalyticsService,
        screenOrientationService: ScreenOrientationService,
        dateCalculationService: DateCalculationService,
        ticketActionsService: TicketActionsService,
        nav: NavController,
        translatePipe: TranslateObjectFieldPipe,
        productsFacade: ProductsFacade,
        productsService: ProductsService
    ) {
        super(
            env,
            locale,
            modalCtrl,
            formBuilder,
            accountTicketsFacade,
            applicationFacade,
            coreFacade,
            appStartupService,
            ticketService,
            bpObservable,
            favoritesFacade,
            authService,
            router,
            activatedRoute,
            translate,
            networkService,
            analyticsService,
            screenOrientationService,
            dateCalculationService,
            ticketActionsService,
            nav,
            translatePipe,
            productsFacade,
            productsService
        );
    }

    async ngOnInit(): Promise<void> {
        const isGroup = this.ticket?.userProfiles?.[0]?.group;
        this.travellers = isGroup
            ? this.ticketService.getSelectedTravellerTypesOnTicket(
                  this.ticket.userProfiles[0].companionProfiles,
                  this.ticket.dynamicProductParameters
              )
            : this.translateString(this.ticket.userProfiles?.[0]);
    }

    reactivateTicket(ticket: Ticket): void {
        this.ticketsFacade.reactivateTicket(String(ticket.id ?? ticket.docNum));
        this.refreshTickets.emit();
    }

    toggleExpandCollapseDetailedInfo(): void {
        this.accordionValue = this.accordionValue ? undefined : 'detailsShown';
    }

    isManualActivationEnabled(ticket: Ticket): boolean {
        return super.isManualActivationEnabled(ticket);
    }

    isMenuReactivationEnabled(ticket: Ticket): boolean {
        const AWAITING_REACTIVATION = 'AWAITING_REACTIVATION';
        return this.env.TICKET_ACTIONS?.includes(AWAITING_REACTIVATION) && ticket.status === AWAITING_REACTIVATION;
    }
}
